import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import darkIcon from "../../assets/img/icon-dark-theme.svg";
import lightIcon from "../../assets/img/icon-light-theme.svg";
import { Switch } from "@headlessui/react";
import useDarkMode from "../../hooks/useDarkMode";
import { guestToken, login } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { channel } from "../../redux/channel/action";
import { useSelector } from "react-redux";
import { queryByStore } from "../../redux/query-by-store/action";
import { organizationUnits } from "../../redux/organizationUnits/action";
import { library } from "../../redux/library/action";
import { countries } from "../../redux/countries/action";
import { states } from "../../redux/states/action";
import { websites } from "../../redux/websites/action";

export default function Login() {
	const naviage = useNavigate()
	const dispatch = useAppDispatch()
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')

	const [colorTheme, setTheme] = useDarkMode();

	const [darkSide, setDarkSide] = useState(
		colorTheme === "light" ? true : false
	);

	const toggleDarkMode = (checked: any) => {
		setTheme(colorTheme);
		setDarkSide(checked);
	};

	const onFinish = () => {
		dispatch(login({ loginData: { "Username": email, "Password": password, "LoginWithOtp": false, "Otp": "" } })).then(() => {
			naviage('/')
		})
	};

	useEffect(() => {
		const guest = localStorage.getItem('guest-token')
		//if (!guest) {
			dispatch(guestToken()).then(()=>{
			dispatch(channel.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`,entity:'channels',jsonData:{}}))
			}).then(()=>{
				dispatch(queryByStore.list({url:`https://iam.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/localization/query-by-store`,entity:'queryByStores',jsonData:{}}))
			}).then(()=>{
				dispatch(organizationUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,entity:'organizationUnits',jsonData:{}}))
			}).then(()=>{
				dispatch(library.read({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`}))
			}).then(()=>{
				dispatch(countries.read({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`}))
			}).then(()=>{
				dispatch(states.read({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`}))
			}).then(()=>{
				dispatch(websites.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/cms/websites/query-by-names`,entity:'websites',jsonData:{
					
						"Records": [
							{
								"WebSiteName": "ulip"
							}
						]
					
				}}))
			})
			
		//}
	}, [])

	return (
		<>
			<div className="flex h-screen bg-slate-200 dark:bg-indigo-500">
				<div className="container mx-auto px-4 ">
					<div className="flex content-center items-center justify-center h-full">
						<div className="w-full lg:w-4/12 px-4">
							<div className="relative bg-indigo-500 dark:bg-white flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
								<div className="rounded-t mb-0 px-6 py-6">
									<div className="flex flex-row items-center justify-between text-center">
										<div className="text-white dark:text-indigo-500 text-xl font-bold">
											LOGIN
										</div>
										<div className="flex flex-row  text-white dark:text-indigo-500 dark:bg-slate-200 bg-black text-xl font-bold p-2 rounded">
											<img src={lightIcon} alt="sun indicating light mode" className="px-2" />
											<Switch
												checked={darkSide}
												onChange={toggleDarkMode}
												className={`${darkSide ? "bg-[#635fc7]" : "bg-gray-200"
													} relative inline-flex h-5 w-11 items-center rounded-full`}
											>
												<span
													className={`${darkSide ? "translate-x-6" : "translate-x-1"
														} inline-block h-4 w-4 transform rounded-full bg-white transition`}
												/>
											</Switch>
											<img src={darkIcon} alt="moon indicating dark mode" className="px-2" />
										</div>
									</div>
									<hr className="mt-6 border-b-1 border-slate-300 dark:border-indigo-300" />
								</div>
								<div className="flex-auto px-4 lg:px-10 py-10 pt-0">
									<form >
										<div className="relative w-full mb-3">
											<label
												className="block uppercase text-slate-200 dark:text-indigo-500 text-xs font-bold mb-2"
												htmlFor="grid-password"
											>
												User Id
											</label>
											<input
												type="email"
												className="border-0 px-3 py-3 text-indigo-600  bg-slate-200 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
												placeholder="Email"
												value={email}
												onChange={(e) => setEmail(e.target.value)}
											/>
										</div>

										<div className="relative w-full mb-3">
											<label
												className="block uppercase text-slate-200 dark:text-indigo-500 text-xs font-bold mb-2"
												htmlFor="grid-password"
											>
												Password
											</label>
											<input
												type="password"
												className="border-0 px-3 py-3  text-indigo-600  bg-slate-200   rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
												placeholder="Password"
												value={password}
												onChange={(e) => setPassword(e.target.value)}

											/>
										</div>
										<div>
											<label className="inline-flex items-center cursor-pointer">
												<input
													id="customCheckLogin"
													type="checkbox"
													className="form-checkbox border-0 rounded placeholder-slate-200 dark:placeholder-indigo-200 ml-1 w-5 h-5 ease-linear transition-all duration-150"
												/>
												<span className="ml-2 text-sm font-semibold text-slate-100 dark:text-indigo-600">
													Remember me
												</span>
											</label>
										</div>

										<div className="text-center mt-6">
											<button
												className="dark:bg-indigo-500 bg-white -800 text-indigo-500 dark:text-slate-100 active:bg-indigo-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
												type="button" onClick={() => onFinish()}
											>
												Sign In
											</button>
										</div>
									</form>
								</div>
							</div>
							<div className="flex flex-wrap mt-6 relative">
								<div className="w-1/2">
									<a
										href="#pablo"
										onClick={(e) => e.preventDefault()}
										className="text-indigo-500 dark:text-slate-200"
									>
										<small>Forgot password?</small>
									</a>
								</div>
								<div className="w-1/2 text-right">
									<Link to="/auth/register" className="text-indigo-500 dark:text-slate-200">
										<small>Create new account</small>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
